export default {
  name: "နံမယ်",
  tel: "တယ်လီဖုန်း",
  save: "ကယ်ဆယ်",
  confirm: "အတည်ပြု",
  cancel: "ပျက်စေ",
  delete: "ဖျက်",
  complete: "အပြီးသတ်",
  loading: "တင် ...",
  telEmpty: "ကျေးဇူးပြု. သင့်ဖုန်းနံပါတ်ကိုဖြည့်ပါ",
  nameEmpty: "ကျေးဇူးပြုပြီးသင့်နာမည်ကိုဖြည့်ပါ",
  nameInvalid: "ကျေးဇူးပြု. မှန်ကန်သောအမည်ထည့်ပါ",
  confirmDelete: "သင်ဖျက်ချင်တာသေချာလား",
  telInvalid: "ကျေးဇူးပြု. မှန်ကန်သောဖုန်းနံပါတ်ကိုရိုက်ထည့်ပါ",
  vanCalendar: {
    end: "အပြီးသတ်",
    start: "စက်နှိုး",
    title: "ဘဲှ့",
    confirm: "အတည်ပြု",
    startEnd: "စတင်ပါ",
    weekdays: {
      "0": "နေ့",
      "1": "တစ်",
      "2": "နှစ်",
      "3": "သုံး",
      "4": "လေး",
      "5": "ငါး",
      "6": "ခေြာက်"
    }
  },
  vanCascader: { select: "ကျေးဇူးပြုပြီးရွေးချယ်ပါ" },
  vanContactCard: { addText: "အဆက်အသွယ်တစ်ခုထည့်ပါ" },
  vanContactList: { addText: "ဆက်သွယ်ရန်ပုဂ္ဂိုလ်သစ်" },
  vanPagination: { prev: "Page", next: "နောက်စာမျက်နှာ" },
  vanPullRefresh: {
    pulling: "Refresh မှဆွဲထုတ် ...",
    loosing: "refresh ကိုလွှတ်ပေးပါ ..."
  },
  vanSubmitBar: { label: "အားလုံး:" },
  vanCoupon: { unlimited: "အသုံးပြုမှုကန့်သတ်ချက်များမရှိပါ" },
  vanCouponCell: { title: "ကူပွန်", tips: "မရရှိနိုင်ပါ" },
  vanCouponList: {
    empty: "အဘယ်သူမျှမကူပွန်",
    exchange: "လဲလှယ်",
    close: "အဘယ်သူမျှမကူပွန်",
    enable: "အသုံးပြုနိုင်",
    disabled: "မရရှိနိုင်ပါ",
    placeholder: "ကျေးဇူးပြု. လျှော့စျေးကုဒ်ကိုရိုက်ထည့်ပါ"
  },
  vanAddressEdit: {
    area: "မေြရာ",
    postal: "စာတိုက်သင်္ကေတ",
    areaEmpty: "ဒေသတစ်ခုရွေးပါ",
    addressEmpty: "အသေးစိတ်လိပ်စာဖြည့်ပါ",
    postalEmpty: "စာတိုက်ကုဒ်ပုံစံမမှန်ကန်ပါ",
    defaultAddress: "ပုံမှန်ရေကြောင်းလိပ်စာအဖြစ်သတ်မှတ်",
    telPlaceholder: "Consignee မိုဘိုင်းနံပါတ်",
    namePlaceholder: "အဆိုပါ consignee ၏အမည်",
    areaPlaceholder: "ပြည်နယ် / မြို့ / ခရိုင်ကိုရွေးပါ"
  },
  vanAddressEditDetail: {
    label: "စကားပေြာဟော",
    placeholder:
      "လမ်းတံခါးနံပါတ်, ကြမ်းပြင်ခန်းနံပါတ်နှင့်အခြားသတင်းအချက်အလက်များ"
  },
  vanAddressList: { add: "လိပ်စာထည့်ပါ" }
};
